
        require('./index.scss');
        'use strict';

var _user = require('model/service/user');

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ = window.$;
var _ = window._;
var $mod = $('.module-loupan-nav');
var $loupanModel = require('model/service/loupan.js');
var hoverExposure = require('assets/util/hover-exposure.js');

var _module = {
    init: function init() {
        this.userInfo();
        new hoverExposure($mod.find('.phone-dial-code'), 3000, {
            type: 'bg',
            eventname: 'xfpcbhewm',
            positionId: '3'
        });
        this.navFixInit();
        this.resizeNav();
    },
    userInfo: function userInfo() {
        _user2['default'].getInfo().then(function (data) {
            var userPhone = data.mobile ? data.mobile : '';
            var kftParams = {
                cityId: $mod.attr('data-city_id'),
                pid: $mod.attr('data-proj_id'),
                activeTitle: $mod.attr('data-proj_name'),
                signupNum: $mod.attr('data-bm_count'),
                baomingType: $mod.attr('data-baomingtype'),
                source: $mod.attr('data-source'),
                baomingPage: 'loupan-info'
            };
            // $loupanModel.getLoupanKanfang({
            //     cityId: $mod.attr('data-city_id'),
            //     pid: $mod.attr('data-proj_id')
            // }).then((res) => {
            //     // console.log(res);
            //     if (parseInt(res.code, 10) === 200) {
            //         if (res.data.kanfangtuanInfo && res.data.kanfangtuanInfo.lineId) {
            //             var resData = res.data.kanfangtuanInfo;
            //             kftParams.baomingType = 'kanfang';
            //             kftParams.signupNum = resData.totalNum;
            //             kftParams.phone = userPhone;
            //             kftParams.cityId = resData.cityId;
            //             kftParams.pid = resData.projectId;
            //             kftParams.activeTitle = resData.title;
            //             kftParams.lineId = resData.lineId;
            //             kftParams.joinSource = resData.fromWhere === '0' ? 17 : 8;
            //         } else {
            //             kftParams.baomingType = 'tongzhi';
            //             kftParams.signupNum = res.data.enrollCount;
            //             kftParams.phone = userPhone;
            //         }
            //     }
            // });
        });
    },
    navFixInit: function navFixInit() {
        var browser = window.navigator.appName;

        if (browser == 'Microsoft Internet Explorer') {
            var b_version = window.navigator.appVersion;
            var version = b_version.split(';');
            var trim_Version = version[1].replace(/[ ]/g, '');
            if (trim_Version == 'MSIE6.0' || trim_Version == 'MSIE7.0' || trim_Version == 'MSIE8.0') {
                return;
            }
        }

        var $nav = $mod.find('.page-nav-area');
        function scrollEvent() {
            var windowWidth = $(window).width();
            var navMLeft = (windowWidth - 1200) / 2;
            var top = $mod.find('.page-nav-area-box').offset().top + 100;
            var scrollTop = $(window).scrollTop();
            // console.log('scrollTop: ',scrollTop);
            if (scrollTop > top - 70) {
                $nav.addClass('fix-top');
                $nav.css({
                    'margin-left': '-' + navMLeft + 'px'
                });
                // $nav.width(windowWidth);
            } else {
                $nav.removeClass('fix-top');
                $nav.css({
                    'margin-left': '0'
                });
            }
        }

        var throttled = _.throttle(scrollEvent, 100);
        $(window).on('scroll', throttled);
        scrollEvent();
    },
    resizeNav: function resizeNav() {
        var resizeNavLeft = _.throttle(function () {
            var windowWidth = $(window).width();
            var navMLeft = (windowWidth - 1200) / 2;
            var $nav = $mod.find('.page-nav-area');
            if ($nav.hasClass('fix-top')) {
                $nav.css({
                    'margin-left': '-' + navMLeft + 'px'
                });
            }
        }, 40);
        $(window).on('resize', resizeNavLeft);
        // mdev.message.listen(function (cmd, data) {
        //     if (cmd == 'resize') {
        //         resizeNavLeft();
        //     }
        // });
    }
};

_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/loupan-common/nav-new/index.js